import CollectGraphicsStatus from "./collect-graphics-status";
import {
    collectGraphicsFilterFieldsConfig,
    getCollectGraphicsInitialValues,
    getCollectGraphicsActiveFiltersCount,
    buildCollectGraphicsFilterState
} from "./collect-graphics-filter-config";

const CollectGraphicsHelpers = {
    Status: CollectGraphicsStatus,
    Filter: {
        fieldsConfig: collectGraphicsFilterFieldsConfig,
        getInitialValues: getCollectGraphicsInitialValues,
        getActiveFiltersCount: getCollectGraphicsActiveFiltersCount,
        buildFilterState: buildCollectGraphicsFilterState
    }
};

export default CollectGraphicsHelpers;